import { defineStore } from 'pinia';
import axios from 'axios';
export const sessionStore = defineStore('sessionStore',{
    actions: {
        getSessionProfilesAction() {
            return axios.get('/api/session/profiles');
        }
    }
});